module.exports = __webpack_public_path__ + "img/ship.e68205d2.png";